import { useQuery } from "@tanstack/react-query";
import { Keys } from "../../common-interfaces/quiries-keys/keysValues";
import { getKey } from "../../common-interfaces/quiries-keys/queries-keys";
import { apiConfig } from "../../config";
import ApiCategories from "./category-api";
import { ICategoryDetailsParams } from "./interfaces/api-category-interfaces";

export const useCategory = () => new ApiCategories(apiConfig());
export const useGetAllCategoriesQuery = ({
  enabled = true,
}: {
  enabled?: boolean;
}) => {
  const category = useCategory();
  return useQuery(
    [...getKey(Keys.query_get_all_categories_Key)],
    () => category.getAllCategories(),
    {
      refetchOnWindowFocus: false,
      enabled: enabled,
    }
  );
};
export const useGetCategoryDetailsQuery = ({
  params,
  enabled = true,
}: {
  params: ICategoryDetailsParams;
  enabled?: boolean;
}) => {
  const category = useCategory();
  return useQuery(
    [...getKey(Keys.query_get_category_details_Key), Object.values(params)],
    () => category.getCategoryDetails(params),
    {
      refetchOnWindowFocus: false,
      enabled: enabled,
    }
  );
};
